import type { ShowcaseDefinition, ComponentCategory, ComponentSection } from './types';
import { ButtonShowcase, ButtonGroupShowcase, DropdownMenuShowcase } from './actions';
import {
  TextShowcase,
  IconShowcase,
  BadgeShowcase,
  AvatarShowcase,
  TooltipShowcase,
} from './display';
import {
  TextFieldShowcase,
  SelectShowcase,
  CheckboxShowcase,
  RadioShowcase,
  DatePickerShowcase,
  FileUploadShowcase,
} from './inputs';
import {
  ModalShowcase,
  AlertShowcase,
  ProgressShowcase,
  SkeletonShowcase,
  SpinnerShowcase,
  ToastShowcase,
} from './feedback';
import {
  TabsShowcase,
  BreadcrumbShowcase,
  SidebarShowcase,
  PaginationShowcase,
} from './navigation';
import {
  TableShowcase,
  ListShowcase,
  TreeViewShowcase,
} from './data';
import {
  CardShowcase,
  StackShowcase,
  GridShowcase,
  DividerShowcase,
  PanelShowcase,
} from './layout';
import {
  EntityFormShowcase,
  DataListShowcase,
  ThemeOverrideShowcase,
} from './integrated';

export const showcaseRegistry: ShowcaseDefinition[] = [
  ButtonShowcase,
  ButtonGroupShowcase,
  DropdownMenuShowcase,
  TextShowcase,
  IconShowcase,
  BadgeShowcase,
  AvatarShowcase,
  TooltipShowcase,
  TextFieldShowcase,
  SelectShowcase,
  CheckboxShowcase,
  RadioShowcase,
  DatePickerShowcase,
  FileUploadShowcase,
  ModalShowcase,
  AlertShowcase,
  ProgressShowcase,
  SkeletonShowcase,
  SpinnerShowcase,
  ToastShowcase,
  TabsShowcase,
  BreadcrumbShowcase,
  SidebarShowcase,
  PaginationShowcase,
  TableShowcase,
  ListShowcase,
  TreeViewShowcase,
  CardShowcase,
  StackShowcase,
  GridShowcase,
  DividerShowcase,
  PanelShowcase,
  EntityFormShowcase,
  DataListShowcase,
  ThemeOverrideShowcase,
];

export const getShowcasesByCategory = (category: ComponentCategory) =>
  showcaseRegistry.filter((s) => s.category === category);

export const getShowcaseById = (id: string) =>
  showcaseRegistry.find((s) => s.id === id);

export const sections: { id: ComponentSection; label: string }[] = [
  { id: 'base', label: 'Base' },
  { id: 'integrated', label: 'Integrated' },
];

export const categories: { id: ComponentCategory; label: string; section: ComponentSection }[] = [
  { id: 'actions', label: 'Actions', section: 'base' },
  { id: 'display', label: 'Display', section: 'base' },
  { id: 'inputs', label: 'Inputs', section: 'base' },
  { id: 'layout', label: 'Layout', section: 'base' },
  { id: 'navigation', label: 'Navigation', section: 'base' },
  { id: 'feedback', label: 'Feedback', section: 'base' },
  { id: 'data', label: 'Data', section: 'base' },
  { id: 'forms', label: 'Forms', section: 'integrated' },
  { id: 'data-lists', label: 'Data Lists', section: 'integrated' },
  { id: 'theming', label: 'Theming', section: 'integrated' },
];

export type {
  ShowcaseDefinition,
  ShowcaseProps,
  ComponentCategory,
  ComponentSection,
  PropDefinition,
  AccessibilityInfo,
} from './types';
